export default {
  name: 'marking--inputCheck',
  apiService: 'shoes',
  apiPath: '/admin/input/func/check',
  urlParamName: 'marking--inputCheck',
};